import Layout from 'components/layout';
import { SetRoutes } from 'components';
import routes from './routes';

const SalesTrackingPage = () => {
  return (
    <Layout>
      <SetRoutes routes={routes} />
    </Layout>
  );
};

export default SalesTrackingPage;
